import { Button, Col, Form, Input, message, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import country from "../../data/country";
import AxiosService from "../../services/APIService";
import IntlPhoneInput from "../../components/IntlPhoneInput";
import leadLogo from "../../assets/whiteLogo.png";
function ExhibitionForm() {
  const apiService = new AxiosService();
  const [searchParams] = useSearchParams();
  const white_label = searchParams.get("wlid");
  const [form] = Form.useForm();

  const [loading, setLoading] = useState({
    formLoading: false,
    otpLoading: false,
  });

  const onFinish = (val) => {
    setLoading({ ...loading, formLoading: true });
    apiService
      .post("/white-label-exhibition/leads-enquiry/create", {
        ...val,
        white_label,
      })
      .then((res) => {
        if (res?.success) {
          message.success("Lead Create Successfully");
          form.resetFields();
        }
      })
      .catch((e) => {
        message.error(e.message);
      })
      .finally(() => {
        setLoading({ ...loading, formLoading: false });
      });
  };
  return (
    <>
      <div className="lead-container">
        <div className="lead-content">
          <div className="logo-wrapper">
            <img src={leadLogo} className="logo" alt="leadLogo" />
          </div>
          <div className="lead-logo-wrapper">
            <h1>3 Months Free AI on your Live Trading Account</h1>
            <p>
              Please fill in your details below to complete your registration.
            </p>
          </div>
        </div>
        <div className="lead-form-block">
          <div className="form-block">
            <Form
              name="lead"
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
              form={form}
            >
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item label="I Want to Register as" name="register_as">
                    <Select
                      placeholder="Select a Option"
                      size="large"
                      options={[
                        { value: "Broker", label: "Broker" },
                        { value: "SD", label: "SD" },
                        { value: "RM", label: "RM" },
                        { value: "TL", label: "TL" },
                        { value: "BDM", label: "BDM" },
                        { value: "IB", label: "IB" },
                        { value: "Investor", label: "Investor" },
                        { value: "Trader", label: "Trader" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col sm={5} xs={8}>
                  <Form.Item label="Prefix" name="prefix">
                    <Select
                      placeholder="Select a Option"
                      defaultValue="Mr"
                      size="large"
                      options={[
                        { value: "Mr", label: "Mr" },
                        { value: "Ms", label: "Ms" },
                        { value: "Mrs", label: "Mrs" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col sm={19} xs={16}>
                  <Form.Item label="Full Name" name="full_name">
                    <Input size="large" placeholder="Enter your full name" />
                  </Form.Item>
                </Col>
                <Col sm={24} xs={24} style={{ marginBottom: "20px" }}>
                  <Form.Item label="Phone Number" name="phone_number">
                    <IntlPhoneInput
                      form={form}
                      name="phone_number"
                      placeholder="Enter your phone number"
                      required={false}
                      defaultCountry={"auto"}
                    />
                  </Form.Item>
                </Col>
                <Col sm={24} xs={24}>
                  <Form.Item label="Email Address" name="email">
                    <Input size="large" placeholder="Enter your email" />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24}>
                  <Form.Item label="Country" name="country">
                    <Select
                      showSearch
                      size="large"
                      placeholder="Select a Country"
                      options={[
                        ...new Set(country.map((item) => item.name)),
                      ].map((ctr) => ({
                        value: ctr,
                        label: ctr,
                      }))}
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .includes(input.toLowerCase()) ||
                        option.value.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24}>
                  <Form.Item label="City" name="city">
                    <Input size="large" placeholder="Enter your City" />
                  </Form.Item>
                </Col>
              </Row>
              <Button
                type="default"
                htmlType="submit"
                className="submit-btn"
                block
                size="large"
                loading={loading.formLoading}
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}
export default ExhibitionForm;
